module.exports = __webpack_public_path__ + "static/media/pool-game.eb5cb0ff.png";